<label>
  <div class="button button-blue-outline" [class.disabled]="disabled">
    <i *ngIf="!file" class="fas fa-file-upload"></i>
    <i *ngIf="file" (click)="onFileCancel($event)" class="fas fa-times"></i>
    {{ file ? file.name : 'Cargar Archivo' }}
  </div>

  <input #inputFile type="file" [accept]="accept" [disabled]="disabled" />
</label>
